export const INVITATION_DATE = "created_at"
export const A_Z = "lastname"

export const SORT_OPTIONS = [
  {label: "admin.constants.sort.AZ.label", value: A_Z},
  {label: "admin.constants.sort.invitationDate.label", value: INVITATION_DATE}
]
